import { create } from "zustand";

/**
 * sessionStore (Master Spec §7): current level id, pause state, and the
 * player's nearest-box index for HUD/UI to read. This store never talks to
 * Three.js directly — GameRuntime reports into it via callback, not the
 * other way around.
 */
interface SessionState {
  levelId: string | null;
  isPaused: boolean;
  nearestBoxIndex: number | null;
  setLevelId: (levelId: string) => void;
  setPaused: (isPaused: boolean) => void;
  setNearestBoxIndex: (index: number | null) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  levelId: null,
  isPaused: false,
  nearestBoxIndex: null,
  setLevelId: (levelId) => set({ levelId }),
  setPaused: (isPaused) => set({ isPaused }),
  setNearestBoxIndex: (nearestBoxIndex) => set({ nearestBoxIndex }),
}));
